import {createTheme} from '@mui/material/styles';

export const RaflTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      light: 'rgba(255,9,84,0.7)',
      main: '#FF0954',
      dark: 'rgba(255,9,84, 0.7)',
    },
    secondary: {
      light: 'rgba(255,9,84,0.7)',
      main: '#000000',
      dark: 'rgba(0, 0, 0, 0.7)',
    },
  },

  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#EAEAEA',
            '&:hover': {
              backgroundColor: '#E4E4E4',
            },
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: '#EAEAEA',
            '&.Mui-focused': {
              backgroundColor: '#E4E4E4',
            },
          },
        },
      },
    },
  },
});
